define([
    'lodash/isString',
    'lodash/get',
    'lodash/groupBy',
    'lodash/sortBy',
    'lodash/map',
    'lodash/intersection',
    'lodash/minBy',
    'lodash/maxBy',
    'lodash/isArray',
    'lodash/assign',
    'util/dates',
    'moment'
], function(
    isString,
    get,
    groupBy,
    sortBy,
    map,
    intersection,
    minBy,
    maxBy,
    isArray,
    assign,
    dates,
    moment
) {
    return ['$http', function ($http) {
        var endpoint = null;

        var eventsFilteredByKeyword = [];

        function setEndpoint(value) {
            endpoint = value;
        }

        function getEvents(type){
            if (!endpoint || !isString(endpoint) || endpoint === '') {
                console.error('Please provide a planner feed.');
            }

            return $http.get(endpoint, { cache: true }).then(function(response) {
                var listType = type || 'day';

                var data = response.data.filter(function (item) {
                    var hasFuturePerformances = (
                        // FuturePerformances exists for item?
                        'FuturePerformances' in item &&
                        // FuturePerformances is an array
                        isArray(item.FuturePerformances) === true &&
                        // Has performances in the future
                        item.FuturePerformances.length
                    );

                    var hasInSessionClasses = (
                        // InSessionClasses exists for item?
                        'InSessionClasses' in item &&
                        // InSessionClasses is an array
                        isArray(item.InSessionClasses) === true &&
                        // Has classes in the future
                        item.InSessionClasses.length
                    );

                    var isValid = (
                        (hasFuturePerformances || hasInSessionClasses) &&
                        // Isn't a fixed package item
                        item.IsFixedPackage !== true &&
                        // Isn't a flex package item
                        item.IsCYOPackage !== true
                    );

                    var keywords = get(item, 'CategoryProductionKeywords', []);

                    var isClass = keywords.some(function (keyword) {
                        return keyword.category === '51_Master Category' && keyword.keyword === 'Class';
                    });

                    var isEvent = keywords.some(function (keyword) {
                        return keyword.category === '51_Master Category' && keyword.keyword === 'Event';
                    });

                    if (listType === 'all') {
                        return isValid;
                    }

                    if (listType === 'class') {
                        return isValid && isClass;
                    }

                    return isValid && isEvent;
                });

                // Denormalise all the events/performances if we're looking at events in the day planner
                if (listType === 'day') {
                    data = data.reduce(function (list, event) {
                        return [].concat(list, event.FuturePerformances.map(function (perf) {
                            var dupe = assign({}, event);

                            // Replace all the important stuff so that the duplicated events work properly
                            dupe.FuturePerformances = [perf];
                            dupe.denormalised = true;
                            dupe.EventDateTime = perf.perf_dt;
                            dupe.NextPerformanceDateTime = perf.perf_dt;
                            dupe.NextPerformanceNumber = perf.perf_no;

                            return dupe;
                        }));
                    }, []);
                }

                return data;
            }).catch(function () {
                return [];
            });
        }

        function getEventsFilteredByKeyword() {
            return this.eventsFilteredByKeyword;
        }

        function filterEventsByKeyword(search, events) {
            var keyword = search || '';
            keyword = keyword.toLowerCase();
            if (keyword.length < 1) {
                this.eventsFilteredByKeyword = events;
            } else {
                keyword = keyword.split(' ');

                this.eventsFilteredByKeyword = events.reduce(function (eventResults, event) {
                    var title = event.Title.toLowerCase();
                    var shortDesc = event.ShortDesc.toLowerCase();

                    var isInTitleOrShortDesc = keyword.some(function (word) {
                        return shortDesc.indexOf(word) !== -1 || title.indexOf(word) !== -1;
                    });

                    if ( isInTitleOrShortDesc ) {
                        eventResults.push(event);
                    }

                    return eventResults;
                },[]);
            }

            return this.eventsFilteredByKeyword;
        }

        function concatCategoryAndKeyword(category, keyword){
            return category+'_'+keyword;
        }

        function filterByDateRange(range, resultsArray) {
            var results = resultsArray.reduce(function(acc, event){
                var eventtime = moment(event.EventDateTime);

                // Only start date?
                if (range.start && !range.end && eventtime.isSameOrAfter(range.start)) {
                    acc.push(event);
                // Only end date?
                } else if (!range.start && range.end && eventtime.isSameOrBefore(range.end)) {
                    acc.push(event);
                // Both dates?
                } else if (range.start && range.end && eventtime.isSameOrAfter(range.start) && eventtime.isSameOrBefore(range.end)) {
                    acc.push(event);
                }

                return acc;
            }, []);
            return results;
        }

        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

        function parseDate(date) {
            var tokens = /^(\D{3}) (\d{1,2}), (\d{4})$/.exec(date);
            return tokens && new Date(tokens[3], months.indexOf(tokens[1]), tokens[2]);
        }

        function setRange(range) {
            this.range = {
                start: range.start ? moment(parseDate(range.start)).startOf('day') : null,
                end: range.end ? moment(parseDate(range.end)).endOf('day') : null
            };
        }

        function filterEventsByFacets(facets, index, resultsArray) {
            var idx = index || 0;
            var resultObj = {};
            if (resultsArray === undefined) {
                resultsArray = this.eventsFilteredByKeyword;
            }

            if (this.range && (this.range.start || this.range.end)) {
                resultsArray = filterByDateRange(this.range, resultsArray);
            }

            var matchingEvents = [];

            if (idx < facets.length) {

                // making a string that contains the category & the keyword
                // so we can mathc on specific categories, in case of duplicated keywords
                // across different categories
                var facetKeywords =  facets[idx].selectedKeywords.reduce(function(acc, keyword) {
                    acc.push(concatCategoryAndKeyword(facets[idx].category,keyword));
                    return acc;
                },[]);
                matchingEvents = [];
                resultsArray =
                resultsArray.reduce(function(matchingEvents, event) {
                    var eventKeywords = event.CategoryProductionKeywords.map(function(item) {
                        return concatCategoryAndKeyword(item.category, item.keyword);
                    });
                    var intersected = intersection(facetKeywords, eventKeywords);
                    if (intersected.length) {
                        matchingEvents.push(event);
                    }
                    return matchingEvents;
                }, matchingEvents);

                idx++;
                return this.filterEventsByFacets(facets, idx, resultsArray);
            }

            resultObj['allResults'] = resultsArray;

            return resultObj;

        }

        function getDayLabel(dateTime) {
            var today = dates.moment();
            var tomorrow = today.clone().add(1, 'days');
            var label;
            if (today.isSame(dates.moment(dateTime), 'day')) {
                label = 'Today';
            } else if (dates.moment(dateTime).isSame(tomorrow, 'day')) {
                label = 'Tomorrow';
            } else {
                label = [
                    dates.format(dateTime, 'dddd MMMM D, '),
                    '<em>',
                    dates.format(dateTime, 'YYYY'),
                    '</em>'
                ].join(' ');
            }
            return label;
        }

        function groupEvents(events) {
            var sortedEvents = sortBy(events, function(event) {
                return dates.format(event.EventDateTime);
            });

            return map(groupBy(sortedEvents, function(event) {
                return dates.moment(event.EventDateTime).startOf('day').format();
            }), function(group, key) {
                return {
                    label: getDayLabel(key),
                    events: group,
                    first: minBy(group, function (item) {
                        return item.EventDateTimestamp;
                    }),
                    last: maxBy(group, function (item) {
                        return item.EventDateTimestamp;
                    })
                };
            });
        }

        return {
            setEndpoint: setEndpoint,
            getEvents: getEvents,
            getDayLabel: getDayLabel,
            filterEventsByKeyword: filterEventsByKeyword,
            filterEventsByFacets: filterEventsByFacets,
            groupEvents: groupEvents,
            eventsFilteredByKeyword: eventsFilteredByKeyword,
            getEventsFilteredByKeyword: getEventsFilteredByKeyword,
            filterByDateRange: filterByDateRange,
            setRange: setRange
        };

    }];
});



// WEBPACK FOOTER //
// ./widgets/services/FTFServices/EventService.js